import { bodyCopySmall, Button, Icon, Tooltip } from '@aon/aon-tws-common-ui';
import { SortableTBody } from '@aon/tws-common-ui-questions/build/lib/components/common/SortableRow';
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ICustomResponseOptionEditModel, IValidationResult } from '../../../models';
import { IApplicationState } from '../../../store';
import { FormattedHeaderRow, FormattedTable, FormattedTh } from '../../common';
import { CustomResponseOptionRow } from './CustomResponseOptionRow';

export const HeaderUnstyled = styled.span`
	font-weight: normal;
	text-transform: none;
	line-height: 1.5em;
`;

const AddButtonContainer = styled.div`
	margin-left: 20px;
	margin-top: 10px;
`;

const AddButtonText = styled.span`
	${bodyCopySmall}
	padding-left: 10px;
`;

export interface ICustomResponseOptionTableProps {
	responseOptions: ICustomResponseOptionEditModel[];
	defaultCultureCode: string;
	validationResult?: IValidationResult;
	HandleFollowUpCheck: (responseOptionId: number) => void;
	UpdateCustomResponseOptionsOrder: (ids: number[]) => void;
	UpdateCustomResponseOptionValue: (value: number | '', responseOptionId: number) => void;
	UpdateCustomResponseOptionText: (text: string, cultureCode: string, responseOptionId: number) => void;
	AddResponseOption: () => void;
	DeleteResponseOption: (responseOptionId: number) => void;
}

export interface ICustomResponseOptionTableState {
	openResponseOptionId?: number;
}

export class CustomResponseOptionTable extends React.PureComponent<ICustomResponseOptionTableProps, ICustomResponseOptionTableState> {
	constructor(props: any) {
		super(props);

		this.state = {};

		this.toggleExpand = this.toggleExpand.bind(this);
		this.onSortingChange = this.onSortingChange.bind(this);
	}

	public toggleExpand(id: number) {
		if (this.state.openResponseOptionId === id) {
			this.setState({ openResponseOptionId: undefined });
		} else {
			this.setState({ openResponseOptionId: id });
		}
	}

	public onSortingChange(itemIds: string[]) {
		const ids = itemIds.map((id) => parseInt(id, 10));
		this.props.UpdateCustomResponseOptionsOrder(ids);
	}

	public render() {
		return (
			<>
				<FormattedTable paddingLeft={20} leftMargin={60} className='tws-custom-response-options-table'>
					<FormattedHeaderRow>
						<FormattedTh flexBasis={55}>{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_LABEL}</FormattedTh>
						{this.props.responseOptions &&
							this.props.responseOptions.length > 0 &&
							this.props.responseOptions[0].translations.length > 1 && (
								<FormattedTh flexBasis={20}>{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_TRANSLATIONS}</FormattedTh>
							)}
						<FormattedTh flexBasis={15}>
							{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE}
							<HeaderUnstyled>
								<Tooltip id='response-option-value-header-tooltip' contentType='html'>
									<strong>{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TITLE}</strong>
									<br />
									<br />
									{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_VALUE_TOOLTIP_TEXT}
								</Tooltip>
							</HeaderUnstyled>
						</FormattedTh>
						<FormattedTh flexBasis={15}>
							{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP}
							<HeaderUnstyled>
								<Tooltip id='response-option-follow-up-header-tooltip' contentType='html'>
									<strong>{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TITLE}</strong>
									<br />
									<br />
									{ContentConstants.CUSTOM_RESPONSEOPTION_HEADER_FOLLOW_UP_TOOLTIP_TEXT}
								</Tooltip>
							</HeaderUnstyled>
						</FormattedTh>
						<FormattedTh flexBasis={10} />
					</FormattedHeaderRow>
					<SortableTBody
						onChange={this.onSortingChange}
						items={this.props.responseOptions}
						disabled={this.state.openResponseOptionId != null}
					>
						{this.props.responseOptions.map((r, key) => (
							<CustomResponseOptionRow
								responseOption={r}
								key={r.id}
								disabled={this.state.openResponseOptionId != null}
								{...this.props}
								index={key}
								ToggleExpand={this.toggleExpand}
								errorMessages={this.getErrorMessage(r.id)}
								deleteDisabled={this.props.responseOptions.length <= 1}
								isExpanded={this.state.openResponseOptionId === r.id}
							/>
						))}
					</SortableTBody>
				</FormattedTable>
				<AddButtonContainer>
					<Button size='xs' floating={true} className='tws-add-response-option-button' onClick={this.props.AddResponseOption}>
						<Icon name='add' />
					</Button>
					<AddButtonText>{ContentConstants.CUSTOM_RESPONSEOPTION_ADD_TEXT}</AddButtonText>
				</AddButtonContainer>
			</>
		);
	}

	private getErrorMessage(index: number): string[] {
		const propertyErrors = this.props.validationResult ? this.props.validationResult.propertyErrors : {};
		if (!propertyErrors || !Object.prototype.hasOwnProperty.call(propertyErrors, index)) {
			return [];
		}

		return propertyErrors[index];
	}
}

export const CustomResponseOptionTableContainer: React.ComponentType<any> = connect((state: IApplicationState) => {
	return { defaultCultureCode: state.survey.surveyEditModel.defaultCultureCode };
})(CustomResponseOptionTable);
